import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('singleDatePicker');

    return {
        DATE_PLACEHOLDER: t('datePlaceholder')
    };
};

export default useTranslation;
